import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { AssetStatisticsRequest } from '../../models/ss-api/requests/asset.statistics.request';
import { ItemCategoryTypesArray, ItemCategoryTypes } from '../../models/domain/item.category.type';
import { AssetStatisticsItemArray } from '../../models/ss-api/responses/asset.statistics.item';
import { ssApiService } from '../../services/ss-api.service';
import * as moment from 'moment';

import { StatsTop200Dialog } from '../../dialogs/stats.top200/stats.top200.dialog';
import { GlobalService } from '../../services/global.service';


@Component({
    selector: 'app-asset-stats',
    templateUrl: './asset.stats.component.html',
    styleUrls: ['./asset.stats.component.css']
})
export class AssetStatsComponent implements OnInit {
    IsBusy: boolean = false;

    // VARIABLES
    Title: string = 'Asset Statistics';

    Statistics: Array<any>;
    TopAssets = {
        10: Array<AssetStatisticsItemArray>(),
        20: Array<AssetStatisticsItemArray>(),
        30: Array<AssetStatisticsItemArray>()
    }

    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Asset Statistics');
        this.LoadStatistics();
    }

    TabChanged(e: any) {

    }

    LoadStatistics() {
        this.IsBusy = true;
        let request = new AssetStatisticsRequest();
        request.StartDate = moment().subtract(30, 'days').toDate();
        request.EndDate = new Date();
        request.MaxItemCount = 500;

        let itemCategoriesTypes = new ItemCategoryTypesArray();
        itemCategoriesTypes.push(0);
        itemCategoriesTypes.push(10);
        itemCategoriesTypes.push(20);
        itemCategoriesTypes.push(30);

        request.ItemCategoryTypes = itemCategoriesTypes;

        let subscription = this.api.AssetStatistics(request).subscribe(result => {

            subscription.unsubscribe();

            this.Statistics = result.Data;

            this.FindTopAssets(200, 10);
            this.FindTopAssets(200, 20);
            this.FindTopAssets(200, 30);
            this.IsBusy = false;
        });
    }

    FindTopAssets(count: number, type: ItemCategoryTypes) {
        for (let i = 0; i < this.Statistics.length; i++) {
            if (this.Statistics[i].ItemCategoryType === type && this.TopAssets[type].length < count) {
                this.TopAssets[type].push(this.Statistics[i]);
            }
        }
    }

    GetTopAssets(type: ItemCategoryTypes) {
        if (this.TopAssets[type]) {
            return this.TopAssets[type];
        } else {
            return new Array<AssetStatisticsItemArray>()
        }
    }

    ConcatLabel(label: string) {
        let regex = new RegExp(/([^\\]+$)/gm);
        let name = label.match(regex).splice(0, 1);

        return name;
    }

    top200Dialog(type: ItemCategoryTypes) {

        let title: string;

        switch (type) {
            case 10:
                title = 'Assets';
                break;
            case 20:
                title = 'Plants & Trees';
                break;
            case 30:
                title = 'Materials';
                break;
            default:
                title = 'Assets';
        }

        let options = {
            height: 800
        }
        let disposable = this.dialogService.addDialog(StatsTop200Dialog, {
            title: title,
            message: 'Confirm message',
            stats: this.GetTopAssets(type)
        }, options).subscribe(response => {
            disposable.unsubscribe();
        });
    }

}
